export default __webpack_public_path__ + "static/media/Mutual___ic_calender.4ecb631a.svg";